<template>
  <v-app>
    <PublicNavBar/>
    <v-main>
      <v-container>        
        <router-view />
      </v-container>
    </v-main> 
  </v-app>

</template>

<script>
import PublicNavBar from '@/components/public/PublicNavBar.vue'

export default {
  name: 'PublicLayout',
  data() {
    return {      
    }
  },  
  components: {
    PublicNavBar
  },
  // computed: {
  //   hideMenu() {
  //     // Hide menu if route is /evaluation or starts with /evaluation/
  //     return this.$route.name === 'EvaluationView' || this.$route.path.startsWith('/evaluation');
  //   }
  // }
}
</script>

<style>
.v-app {
  min-height: 100vh;
}
</style>